import http from 'hub-http/clients/apiClient';

//TODO: use client types

const evaluateFiltersForObject = (filterBranches, objectTypeId, objectId) => {
  // filterBranches should be in object seg format, and be a collection of AND groups
  // objectTypeId should be a string of the object type the filters are for
  // objectId should be a number, the id of the record to test
  return http.post('inbounddb-lists-eval/v2/evaluation/filters/debug', {
    data: {
      objectTypeId,
      objectId,
      filterBranches
    },
    timeout: 60000
  });
};
export default {
  evaluateFiltersForObject
};